const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://gfiur57kel.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://tgiowwjm51.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'hotfix/DO-5377-csp-hardening',
    HOSTNAME: 'https://company.testing.recovery.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.recovery.forwoodsafety.com',
    WEBSOCKET: 'wss://jlmo7ui728.execute-api.us-west-2.amazonaws.com/testing'
  },
};

export default config;